function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((character) => character.charCodeAt(0)));
}

export function storefrontWebPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function getStorefrontPushRegistration() {
  if (!storefrontWebPushSupported()) {
    throw new Error("Este navegador no soporta notificaciones Web Push");
  }
  return navigator.serviceWorker.register("/webpush-sw.js", { scope: "/" });
}

export async function getStorefrontPushSubscription() {
  if (!storefrontWebPushSupported()) return null;
  const registration = await getStorefrontPushRegistration();
  return registration.pushManager.getSubscription();
}

export async function subscribeStorefrontBrowser(publicKey) {
  if (!publicKey) throw new Error("Falta la clave pública VAPID");

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("El permiso de notificaciones no fue concedido");
  }

  const registration = await getStorefrontPushRegistration();
  const existing = await registration.pushManager.getSubscription();
  return (
    existing ||
    registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    })
  );
}

export async function unsubscribeStorefrontBrowser() {
  const subscription = await getStorefrontPushSubscription();
  if (!subscription) return { endpoint: "", removed: false };
  const endpoint = subscription.endpoint;
  const removed = await subscription.unsubscribe();
  return { endpoint, removed };
}
